/* Rekenlogica en validatie voor de productdatabase van de verdunningscalculator.
   Invoer is altijd de hoeveelheid water; de uitkomst is de hoeveelheid product. */
(function (root) {
  const KINDS = ['ratio', 'ml_per_litre', 'ml_per_10_litres', 'oz_per_gallon', 'percent', 'ml_per_car', 'rtu', 'text'];
  const COMPUTED = ['ratio', 'ml_per_litre', 'ml_per_10_litres', 'oz_per_gallon', 'percent'];

  function range(use) {
    const min = Number(use.min);
    const max = use.max === undefined ? min : Number(use.max);
    return { min, max };
  }

  // Productmilliliters bij een gegeven hoeveelheid water (ml). Geeft { low, high }.
  function productForWater(use, waterMl) {
    if (!COMPUTED.includes(use.kind)) throw new Error('Deze dosering kan niet worden uitgerekend.');
    if (!Number.isFinite(waterMl) || waterMl <= 0) throw new Error('Water moet een positief aantal milliliters zijn.');
    const { min, max } = range(use);
    const one = (value) => {
      if (use.kind === 'ratio') return waterMl / value;
      if (use.kind === 'ml_per_litre') return (waterMl / 1000) * value;
      if (use.kind === 'ml_per_10_litres') return (waterMl / 10000) * value;
      if (use.kind === 'oz_per_gallon') return (waterMl / (Number(use.gallons) * 3785.41)) * value * 29.5735;
      return (waterMl * value) / (100 - value);
    };
    const a = one(min);
    const b = one(max);
    return { low: Math.min(a, b), high: Math.max(a, b) };
  }

  function computeMix(use, waterMl) {
    const { low, high } = productForWater(use, waterMl);
    return { productLow: low, productHigh: high, waterMl, totalLow: waterMl + low, totalHigh: waterMl + high, isRange: Math.abs(high - low) > 1e-9 };
  }

  // Een leesbare schaal voor de maatbeker in de animatie.
  function niceScale(ml) {
    const steps = [5, 10, 25, 50, 100, 250, 500, 1000, 2500, 5000];
    return steps.find((step) => ml <= step) || Math.ceil(ml / 1000) * 1000;
  }

  function validateProducts(data) {
    const errors = [];
    const ids = new Set();
    if (!data || !Array.isArray(data.products) || data.products.length === 0) return ['Geen producten.'];
    for (const product of data.products) {
      const tag = product.id || '(zonder id)';
      if (!product.id || ids.has(product.id)) errors.push(`${tag}: id ontbreekt of is dubbel`);
      ids.add(product.id);
      for (const field of ['brand', 'name', 'category']) if (!product[field]) errors.push(`${tag}: ${field} ontbreekt`);
      const source = product.source || {};
      if (!/^https:\/\//.test(source.url || '')) errors.push(`${tag}: bron-URL ontbreekt of is geen https`);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(source.consultedAt || '')) errors.push(`${tag}: raadpleegdatum ontbreekt`);
      if (!Array.isArray(product.uses) || product.uses.length === 0) errors.push(`${tag}: geen doseringen`);
      for (const use of product.uses || []) {
        if (!KINDS.includes(use.kind)) errors.push(`${tag}/${use.id}: onbekend type ${use.kind}`);
        if (use.kind === 'text' && !use.note) errors.push(`${tag}/${use.id}: toelichting ontbreekt`);
        if (use.kind !== 'rtu' && use.kind !== 'text') {
          const { min, max } = range(use);
          if (!(min > 0) || !(max >= min)) errors.push(`${tag}/${use.id}: ongeldige waarden`);
          if (use.kind === 'oz_per_gallon' && !(Number(use.gallons) > 0)) errors.push(`${tag}/${use.id}: aantal gallons ontbreekt`);
          if (use.kind === 'percent' && max >= 100) errors.push(`${tag}/${use.id}: percentage moet onder 100 liggen`);
        }
        if (!use.label) errors.push(`${tag}/${use.id}: label ontbreekt`);
      }
    }
    return errors;
  }


  // "Wat heb ik nodig?": koppelt een doel en een werkwijze aan producten uit dezelfde database.
  const GOALS = {
    wassen: { label: 'Mijn auto wassen', categories: ['shampoo', 'snow foam'] },
    velgen: { label: 'Mijn velgen reinigen', categories: ['velgenreiniger', 'velgen/ijzerverwijderaar'] },
    ijzer: { label: 'IJzerdeeltjes en vliegroest verwijderen', categories: ['ijzerverwijderaar', 'velgen/ijzerverwijderaar'] },
    interieur: { label: 'Het interieur reinigen', categories: ['interieurreiniger', 'allesreiniger', 'kunststofverzorging'] },
    ruiten: { label: 'Ruiten en ruitensproeier', categories: ['glasreiniger', 'ruitensproeiervloeistof'] }
  };
  const label = (use) => `${use.id} ${use.label || ''}`;
  const METHODS = {
    schuimlans: { label: 'Met een schuimlans of foam cannon', test: (use) => /foam|schuim|lans|cannon|hd|hogedruk|pistool|spuitpistool/i.test(label(use)) },
    emmer: { label: 'In een emmer (handwas)', test: (use) => /hand|bucket|manual|emmer|summer|mix/i.test(label(use)) },
    spray: { label: 'Met een sprayer of gebruiksklaar', test: (use) => use.kind === 'rtu' || /dilute|spray|sproei|fles|sensitive|exterior|exterieur|interior|interieur|licht|light|standard|robust|heavy|buiten|binnen/i.test(label(use)) },
    ongeacht: { label: 'Maakt niet uit', test: () => true }
  };

  function matchNeeds(products, { goal, method }) {
    const g = GOALS[goal];
    const m = METHODS[method] || METHODS.ongeacht;
    if (!g) return [];
    const out = [];
    for (const product of products) {
      if (!g.categories.includes(String(product.category).toLowerCase())) continue;
      const uses = (product.uses || []).filter((use) => m.test(use));
      if (uses.length) out.push({ product, uses });
    }
    return out.sort((a, b) => a.product.brand.localeCompare(b.product.brand, 'nl') || a.product.name.localeCompare(b.product.name, 'nl'));
  }

  // Laadt de productlijst: eerst de online database (als een adres is ingesteld), anders het bestand in het thema.
  async function loadProducts({ apiUrl, fallbackUrl, fetchImpl }) {
    const doFetch = fetchImpl || root.fetch.bind(root);
    const attempt = async (url) => {
      const response = await doFetch(url);
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      const errors = validateProducts(data);
      if (errors.length) throw new Error(errors.join('; '));
      return data;
    };
    if (apiUrl) { try { return { ...(await attempt(apiUrl)), source: 'online' }; } catch (error) { /* val terug op het themabestand */ } }
    return { ...(await attempt(fallbackUrl)), source: 'thema' };
  }

  const api = { loadProducts, KINDS, COMPUTED, GOALS, METHODS, matchNeeds, productForWater, computeMix, niceScale, validateProducts };
  root.CleanKompasDilution = api;
})(globalThis);
